/**
 * EdTable通用属性
 */
/**
 * EdTable通用属性
 */
export const TableProps = {
    // table 数据数组
    data: {type: Array, default: () => []},
    // 列的宽度是否自撑开
    fit: {type: Boolean, default: true},
    // table 高度
    height: {type: [String, Number]},
    // 是否带有纵向边框
    border: {type: Boolean, default: true},
    // Table 的尺寸 medium / small / mini
    size: {type: String},
    // 是否要高亮当前行
    highlightCurrentRow: {type: Boolean, default: true},
    // 是否为斑马纹 table
    stripe: {type: Boolean, default: false},
    // Table 的最大高度。合法的值为数字或者单位为 px 的高度。
    maxHeight: {type: [String, Number]},
    // 是否显示表头
    showHeader: {type: Boolean, default: true},
    // 当前行的 key，只写属性
    currentRowKey: {type: [String, Number]},
    // 行的 className 的回调方法，也可以使用字符串为所有行设置一个固定的 className。
    rowClassName: { type: Function },
    // 行的 style 的回调方法，也可以使用一个固定的 Object 为所有行设置一样的 Style。
    rowStyle: { type: [Function, Object] },
    // 单元格的 className 的回调方法，也可以使用字符串为所有单元格设置一个固定的 className。
    cellClassName: { type: [Function, String] },
    // 单元格的 style 的回调方法，也可以使用一个固定的 Object 为所有单元格设置一样的 Style。
    cellStyle: { type: [Function, Object] },
    // 表头行的 className 的回调方法，也可以使用字符串为所有表头行设置一个固定的 className。
    headerRowClassName: { type: [Function, String] },
    // 表头行的 style 的回调方法，也可以使用一个固定的 Object 为所有表头行设置一样的 Style。
    headerRowStyle: {type: [Function, Object]},
    // 表头单元格的 className 的回调方法，也可以使用字符串为所有表头单元格设置一个固定的 className。
    headerCellClassName: {type: [Function, String]},
    // 表头单元格的 style 的回调方法，也可以使用一个固定的 Object 为所有表头单元格设置一样的 Style。
    headerCellStyle: {type: [Function, Object]},
    // 行数据的 Key，用来优化 Table 的渲染；在使用 reserve-selection 功能与显示树形数据时，该属性是必填的。
    rowKey: {type: [Function, String]},
    // 空数据时显示的文本内容，也可以通过 slot="empty" 设置
    emptyText: {type: String},
    // 是否默认展开所有行，当 Table 包含展开行存在或者为树形表格时有效
    defaultExpandAll: {type: Boolean, default: false},
    // 可以通过该属性设置 Table 目前的展开行，需要设置 row-key 属性才能使用，该属性为展开行的 keys 数组。
    expandRowKeys: { type: Array },
    // 默认的排序列的 prop 和顺序。它的prop属性指定默认的排序的列，order指定默认排序的顺序
    defaultSort: { type: Object },
    // tooltip effect 属性 | dark/light
    tooltipEffect: { type: String },
    // 是否在表尾显示合计行
    showSummary: {type: Boolean, default: false},
    // 合计行第一列的文本
    sumText: {type: String},
    // 自定义的合计计算方法
    summaryMethod: { type: Function },
    // 合并行或列的计算方法
    spanMethod: { type: Function },
    // 在多选表格中，当仅有部分行被选中时，点击表头的多选框时的行为。若为 true，则选中所有行；若为 false，则取消选择所有行
    selectOnIndeterminate: {type: Boolean, default: true},
    // 展示树形数据时，树节点的缩进
    indent: {type: Number, default: 16},
    // 是否懒加载子节点数据
    lazy: {type: Boolean, default: true},
    // 加载子节点数据的函数，lazy 为 true 时生效，函数第二个参数包含了节点的层级信息
    load: { type: Function },
    // 渲染嵌套数据的配置选项
    treeProps: {type: Object}
}

/**
 * EdTable组件属性
 */
export default {
    // 是否显示操作区域
    isOperate: {type: Boolean, default: true},
    // 操作区域宽度
    operateWidth: {type: [String, Number], default: 140},
    // 对应列的类型 selection 多选 | index 索引值 | expand 可展开 | radio 单选
    columnType: {type: String},
    // 表格列的配置描述
    columns: {type: Array, default: () => []},
    // 分页数据
    pagination: {type: [Boolean, Object]},
    //加载进度
    loading: {type: Boolean, default: true},
    // 操作栏是否固定
    operateFixed: {type: [Boolean, String], default: false},

    // element table props
    ...TableProps
}
